
import { createElement } from "react";
import React from "react";
import { useEffectOnce } from "./fable_modules/Feliz.2.9.0/Internal.fs.js";
import { RouterModule_nav } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { ofArray, singleton } from "./fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { defaultOf } from "./fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { useTranslation } from "react-i18next";
import { NavigationContainer } from "./NavigationContainer.js";
import { unwrap } from "./fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { CategoryRoutes, AuthorizedUrl } from "./Routes.js";
import { OnboardingHubView } from "./OnboardingHub/View.js";
import { ImportGuideView } from "./OnboardingHub/ImportGuide.js";
import { ContactGuideView } from "./OnboardingHub/ContactGuide.js";
import { CreateAccountPage } from "./CreateAccount.js";
import { StocktakingOverview } from "./Stocktaking/Overview/View.js";
import { EditFormView, NewFormView, CopyFormView } from "./Stocktaking/Form/View.js";
import { DetailView } from "./Stocktaking/Detail/View.js";
import { DetailView as DetailView_1 } from "./Stocktaking/StocktakingList/View.js";
import { ResultView } from "./Stocktaking/Result/View.js";
import { DashboardView } from "./Dashboard/View.js";
import { OverviewView } from "./Tools/Overview/View.js";
import { EditToolView, CopyNewToolView, NewToolView } from "./Tools/Tool/Form/View.js";
import { ProcedureId, ProcedureTemplateId, InspectionTemplateId, BusinessUnitId, SetId as SetId_2, UserId as UserId_9, LocationId, StorageId, ConsumableId as ConsumableId_2, ToolId as ToolId_5 } from "./Shared/Shared.js";
import { ViewToolView } from "./Tools/Tool/Details/View.js";
import { EditToolView as EditToolView_1, CopyNewToolWithQantityView, NewToolWithQantityView } from "./Tools/ToolWithQuantity/Form/View.js";
import { ToolWithQuantityDetailView } from "./Tools/ToolWithQuantity/Details/View.js";
import { ConsumablesOverviewView } from "./Consumables/Overview/View.js";
import { EditConsumablesView, CopyNewConsumablesView, NewConsumablesView } from "./Consumables/Form/View.js";
import { ConsumableDetailOverviewView } from "./Consumables/Detail/View.js";
import { StoragesOverview } from "./Storage/Overview/View.js";
import { StorageEditView, StorageNewView } from "./Storage/Form/View.js";
import { StorageDetailsView } from "./Storage/Detail/View.js";
import { LocationOverview } from "./Location/Overview/View.js";
import { EditLocationView, NewLocationView } from "./Location/Form/View.js";
import { LocationDetailsView } from "./Location/Detail/View.js";
import { UserOverviewView } from "./ToolBox/Overviews/User/View.js";
import { EditUserView, NewUserView } from "./Receiver/User/View.js";
import { ToolBoxView } from "./ToolBox/Detail/View.js";
import { EmployeeOverviewView } from "./ToolBox/Overviews/Employee/View.js";
import { EditEmployeeView, NewEmployeeView } from "./Receiver/Employee/View.js";
import { ProjectOverviewView } from "./ToolBox/Overviews/Project/View.js";
import { EditProjectView, NewProjectView } from "./Receiver/Project/View.js";
import { RoomOverviewView } from "./ToolBox/Overviews/Room/View.js";
import { EditRoomView, NewRoomView } from "./Receiver/Room/View.js";
import { SubcontractorOverviewView } from "./ToolBox/Overviews/Subcontractor/View.js";
import { EditSubcontractorView, NewSubcontractorView } from "./Receiver/Subcontractor/View.js";
import { ConstructionSiteOverviewView } from "./ToolBox/Overviews/ConstructionSite/View.js";
import { EditConstructionSiteView, NewConstructionSiteView } from "./Receiver/ConstructionSite/View.js";
import { ExternalPersonOverviewView } from "./ToolBox/Overviews/ExternalPerson/View.js";
import { EditExternalPersonView, NewExternalPersonView } from "./Receiver/ExternalPerson/View.js";
import { StudentOverviewView } from "./ToolBox/Overviews/Student/View.js";
import { EditStudentView, NewStudentView } from "./Receiver/Student/View.js";
import { SchoolClassOverviewView } from "./ToolBox/Overviews/SchoolClass/View.js";
import { EditSchoolClassView, NewSchoolClassView } from "./Receiver/SchoolClass/View.js";
import { VehiclesOverviewView } from "./ToolBox/Overviews/Vehicle/View.js";
import { VehicleEditView, NewVehicleView } from "./Receiver/Vehicle/View.js";
import { SystemSettingsView } from "./Settings/SystemSettings/View.js";
import { View } from "./Settings/CustomProperty/View.js";
import { View as View_1 } from "./Settings/Categories/Details/View.js";
import { EditCategoryView, NewCategoryView } from "./Settings/Categories/Form/View.js";
import { CategoriesOverviewView } from "./Settings/Categories/Overview/View.js";
import { UsersOverviewView } from "./Settings/UserManagement/Users/Overview/View.js";
import { ApiReceiversOverviewView } from "./Settings/UserManagement/ApiReceiver/Overview/View.js";
import { InvalidAuthError, InternalServerError, Forbidden, Unauthorized, BadRequest, NotFound } from "./Error.js";
import { ApiReceiverEditView, NewApiReceiverView } from "./Settings/UserManagement/ApiReceiver/Form/View.js";
import { DetailsView } from "./Settings/UserManagement/ApiReceiver/Details/View.js";
import { ProfileView } from "./Profile/View.js";
import { CustomerDataView } from "./CustomerData/Detail/View.js";
import { ReceiversOverviewView } from "./ToolBox/View.js";
import { View as View_2 } from "./ToolBox/Dispolist/View.js";
import { ViewWithQueryParameter, View as View_3 } from "./Report/View.js";
import { View as View_4 } from "./Support/View.js";
import { AccountNotActivated, AccountCanceled, TestphaseEnd } from "./AccountBlocked/View.js";
import { BarcodeShopView } from "./Shop/View.js";
import { View as View_5 } from "./Importer/View.js";
import { View as View_6 } from "./Importer/Tool/View.js";
import { View as View_7 } from "./Importer/ToolWithQuantity/View.js";
import { View as View_8 } from "./Importer/Consumable/View.js";
import { View as View_9 } from "./Importer/Label/View.js";
import { View as View_10 } from "./Importer/User/View.js";
import { View as View_11 } from "./Importer/Employee/View.js";
import { View as View_12 } from "./Importer/Subcontractor/View.js";
import { View as View_13 } from "./Importer/Room/View.js";
import { View as View_14 } from "./Importer/Project/View.js";
import { View as View_15 } from "./Importer/ExternalPerson/View.js";
import { View as View_16 } from "./Importer/Student/View.js";
import { View as View_17 } from "./Importer/SchoolClass/View.js";
import { View as View_18 } from "./Importer/ConstructionSite/View.js";
import { ImporterView } from "./Importer/Vehicle/View.js";
import { View as View_19 } from "./Importer/LastInspectionDate/View.js";
import { View as View_20 } from "./Importer/InspectionResult/View.js";
import { View as View_21 } from "./Importer/Document/View.js";
import { View as View_22 } from "./Importer/Updater/Tool/View.js";
import { View as View_23 } from "./Importer/Updater/ToolWithQuantity/View.js";
import { View as View_24 } from "./Importer/Updater/Consumable/View.js";
import { View as View_25 } from "./Importer/Updater/Set/View.js";
import { View as View_26 } from "./Importer/Updater/ConsumableStock/View.js";
import { View as View_27 } from "./Importer/Updater/ToolWithQuantityStock/View.js";
import { OverviewView as OverviewView_1 } from "./InventoryLists/Overview/View.js";
import { EditInventoryListView, NewInventoryListView } from "./InventoryLists/Form/View.js";
import { DetailInventoryListView } from "./InventoryLists/Detail/View.js";
import { CalendarView } from "./Calendar/View.js";
import { AvailabilityView } from "./Availability/View.js";
import { UtilizationView } from "./Utilization/View.js";
import { ReservationView } from "./Reservation/Overview/View.js";
import { EditReservationForm, NewReservationForm } from "./Reservation/Form/View.js";
import { DetailReservationView } from "./Reservation/Detail/View.js";
import { CopySetView, EditSetView, NewSetView } from "./Sets/Form/View.js";
import { SetDetailView } from "./Sets/Detail/View.js";
import { OverviewView as OverviewView_2 } from "./BusinessUnit/Overview/View.js";
import { EditBusinessUnitView, NewBusinessUnitView } from "./BusinessUnit/Form/View.js";
import { BusinessUnitDetailView } from "./BusinessUnit/Detail/View.js";
import { OverviewView as OverviewView_3 } from "./Settings/InspectionTemplate/Overview/View.js";
import { EditView, NewView } from "./Settings/InspectionTemplate/Form/View.js";
import { DetailView as DetailView_2 } from "./Settings/InspectionTemplate/Detail/View.js";
import { OverviewView as OverviewView_4 } from "./ProcedureTemplate/Overview/View.js";
import { CopyView, EditView as EditView_1, NewView as NewView_1 } from "./ProcedureTemplate/Form/View.js";
import { ResultsView } from "./Procedure/Results/View.js";
import { LabelPrintPage } from "./LabelPrint/View.js";
import { ChatOverviewView } from "./Chat/Overview/View.js";
import { LoadingPage } from "./LoadingPage.js";
import { View as View_28 } from "./OnboardingWizard/View.js";
import { AssignEmailNotificationRejectSuccessMessage, AssignEmailNotificationSuccessMessage } from "./Notification/AcceptEmailNotification/AssignEmailNotificationSuccess.js";
import { ProcedureResultsPrintView } from "./Procedure/Results/PrintView.js";
import { AssignmentProtocolView } from "./Widgets/AssignmentProtocol.js";
import { AcceptEmailNotificationView } from "./Notification/AcceptEmailNotification/View.js";
import { hasAuthParams, useAuth } from "react-oidc-context";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { equals } from "./fable_modules/fable-library-js.5.0.0-rc.2/Util.js";

export function RedirectToTools() {
    useEffectOnce(() => {
        RouterModule_nav(singleton("tools"), 2, 1);
    });
    return defaultOf();
}

export function ActiveAuthorizedPage(props) {
    const t = useTranslation()[0];
    const navigationContainer = (currentUrl, title, subTitle, testId, subTestId, subView) => createElement(NavigationContainer, {
        AccountSettings: props.AccountSettings,
        Configuration: props.Configuration,
        CurrentUrl: currentUrl,
        CurrentUser: props.CurrentUser,
        IsInTestphase: props.IsInTestphase,
        OnLogout: props.OnLogout,
        SubTestId: unwrap(subTestId),
        SubTitle: unwrap(subTitle),
        SubView: subView,
        TestId: testId,
        Title: title,
        UserData: props.UserData,
    });
    const matchValue = props.Url;
    switch (matchValue.tag) {
        case 89:
            return navigationContainer(new AuthorizedUrl(89, []), t("navbar.onboarding_hub"), undefined, "onboarding-hub-top-navigation", undefined, createElement(OnboardingHubView, {
                OnChoose: (choice) => {
                    if (choice.tag === 1) {
                    }
                    else {
                        RouterModule_nav(ofArray(["getting-started", "import"]), 1, 1);
                    }
                },
                OnSkip: () => {
                    RouterModule_nav(ofArray(["dashboard"]), 1, 1);
                },
            }));
        case 90:
            return navigationContainer(new AuthorizedUrl(90, []), t("navbar.onboarding_hub"), undefined, "onboarding-import-top-navigation", undefined, createElement(ImportGuideView, {
                OnBack: () => {
                    RouterModule_nav(ofArray(["getting-started"]), 1, 1);
                },
                OnGoToImporter: () => {
                    RouterModule_nav(ofArray(["importer"]), 1, 1);
                },
            }));
        case 91:
            return navigationContainer(new AuthorizedUrl(91, []), t("navbar.onboarding_hub"), undefined, "onboarding-contact-top-navigation", undefined, createElement(ContactGuideView, {
                OnBack: () => {
                    RouterModule_nav(ofArray(["getting-started"]), 1, 1);
                },
            }));
        case 1:
            return createElement(CreateAccountPage, null);
        case 2:
            return navigationContainer(new AuthorizedUrl(2, []), t("stocktaking.stocktaking"), undefined, "stocktaking-top-navigation", undefined, createElement(StocktakingOverview, {
                AccountSettings: props.AccountSettings,
            }));
        case 5:
            return navigationContainer(new AuthorizedUrl(2, []), t("stocktaking.stocktaking"), undefined, "stocktaking-top-navigation", undefined, createElement(CopyFormView, {
                CustomerConfiguration: props.Configuration,
                StocktakingId: matchValue.fields[0],
            }));
        case 6:
            return navigationContainer(new AuthorizedUrl(2, []), t("stocktaking.stocktaking"), undefined, "stocktaking-top-navigation", undefined, createElement(NewFormView, {
                CustomerConfiguration: props.Configuration,
            }));
        case 4:
            return navigationContainer(new AuthorizedUrl(2, []), t("stocktaking.stocktaking"), undefined, "stocktaking-top-navigation", undefined, createElement(EditFormView, {
                CustomerConfiguration: props.Configuration,
                StocktakingId: matchValue.fields[0],
            }));
        case 3:
            return navigationContainer(new AuthorizedUrl(2, []), t("stocktaking.stocktaking"), undefined, "stocktaking-top-navigation", undefined, createElement(DetailView, {
                StocktakingId: matchValue.fields[0],
            }));
        case 7:
            return navigationContainer(new AuthorizedUrl(2, []), t("stocktaking.stocktaking"), t("stocktaking.stocktaking_list"), "stocktaking-top-navigation", undefined, createElement(DetailView_1, {
                StocktakingId: matchValue.fields[0],
                StocktakingListId: matchValue.fields[1],
            }));
        case 8:
            return navigationContainer(new AuthorizedUrl(2, []), t("stocktaking.stocktaking"), t("stocktaking.stocktaking_result"), "stocktaking-top-navigation", undefined, createElement(ResultView, {
                StocktakingId: matchValue.fields[0],
            }));
        case 0: {
            const matchValue_1 = props.UserData.Role;
            switch (matchValue_1) {
                case "administrator":
                case "system":
                case "toolManager":
                    return navigationContainer(new AuthorizedUrl(0, []), t("dashboard.title"), undefined, "dashboard-top-navigation", undefined, createElement(DashboardView, null));
                default:
                    return createElement(RedirectToTools, null);
            }
        }
        case 9:
            return navigationContainer(new AuthorizedUrl(9, []), t("general.tool"), undefined, "tool-top-navigation", undefined, createElement(OverviewView, {
                CurrentUser: props.CurrentUser,
                UserData: props.UserData,
            }));
        case 10:
            return navigationContainer(new AuthorizedUrl(9, []), t("general.tool"), undefined, "", undefined, createElement(NewToolView, {
                CustomerConfiguration: props.Configuration,
                UserData: props.UserData,
            }));
        case 11:
            return navigationContainer(new AuthorizedUrl(9, []), t("general.tool"), undefined, "", undefined, createElement(CopyNewToolView, {
                CustomerConfiguration: props.Configuration,
                ToolId: new ToolId_5(matchValue.fields[0]),
                UserData: props.UserData,
            }));
        case 12:
            return navigationContainer(new AuthorizedUrl(9, []), t("general.tool"), undefined, "", undefined, createElement(ViewToolView, {
                CurrentUser: props.CurrentUser,
                ToolId: new ToolId_5(matchValue.fields[0]),
                UserData: props.UserData,
            }));
        case 13:
            return navigationContainer(new AuthorizedUrl(9, []), t("general.tool"), undefined, "", undefined, createElement(EditToolView, {
                CustomerConfiguration: props.Configuration,
                ToolId: new ToolId_5(matchValue.fields[0]),
                UserData: props.UserData,
            }));
        case 14:
            return navigationContainer(new AuthorizedUrl(9, []), t("general.tool_with_quantity"), undefined, "", undefined, createElement(NewToolWithQantityView, {
                CustomerConfiguration: props.Configuration,
                UserData: props.UserData,
            }));
        case 15:
            return navigationContainer(new AuthorizedUrl(9, []), t("general.tool_with_quantity"), undefined, "", undefined, createElement(CopyNewToolWithQantityView, {
                CustomerConfiguration: props.Configuration,
                ToolId: new ToolId_5(matchValue.fields[0]),
                UserData: props.UserData,
            }));
        case 16:
            return navigationContainer(new AuthorizedUrl(9, []), t("general.tool_with_quantity"), undefined, "", undefined, createElement(ToolWithQuantityDetailView, {
                ToolId: new ToolId_5(matchValue.fields[0]),
                UserData: props.UserData,
            }));
        case 17:
            return navigationContainer(new AuthorizedUrl(9, []), t("general.tool_with_quantity"), undefined, "", undefined, createElement(EditToolView_1, {
                CustomerConfiguration: props.Configuration,
                ToolId: new ToolId_5(matchValue.fields[0]),
                UserData: props.UserData,
            }));
        case 18:
            return navigationContainer(new AuthorizedUrl(18, []), t("consumable.title"), undefined, "consumable-top-navigation", undefined, createElement(ConsumablesOverviewView, {
                AccountSettings: props.AccountSettings,
                UserData: props.UserData,
            }));
        case 19:
            return navigationContainer(new AuthorizedUrl(18, []), t("consumable.title"), undefined, "", undefined, createElement(NewConsumablesView, {
                CustomerConfiguration: props.Configuration,
                UserData: props.UserData,
            }));
        case 20:
            return navigationContainer(new AuthorizedUrl(18, []), t("consumable.title"), undefined, "", undefined, createElement(CopyNewConsumablesView, {
                ConsumableId: new ConsumableId_2(matchValue.fields[0]),
                CustomerConfiguration: props.Configuration,
                UserData: props.UserData,
            }));
        case 21:
            return navigationContainer(new AuthorizedUrl(18, []), t("consumable.title"), undefined, "", undefined, createElement(ConsumableDetailOverviewView, {
                ConsumableId: matchValue.fields[0],
                UserData: props.UserData,
            }));
        case 22:
            return navigationContainer(new AuthorizedUrl(18, []), t("consumable.title"), undefined, "", undefined, createElement(EditConsumablesView, {
                ConsumableId: new ConsumableId_2(matchValue.fields[0]),
                CustomerConfiguration: props.Configuration,
                UserData: props.UserData,
            }));
        case 23:
            return navigationContainer(new AuthorizedUrl(23, []), t("settings.title"), t("storage.title"), "settings-top-navigation", "storage-sub-top-navigation", createElement(StoragesOverview, null));
        case 24:
            return navigationContainer(new AuthorizedUrl(23, []), t("settings.title"), t("storage.title"), "", undefined, createElement(StorageNewView, null));
        case 26:
            return navigationContainer(new AuthorizedUrl(23, []), t("settings.title"), t("storage.title"), "", undefined, createElement(StorageEditView, {
                StorageId: new StorageId(matchValue.fields[0]),
            }));
        case 25:
            return navigationContainer(new AuthorizedUrl(23, []), t("settings.title"), t("storage.title"), "", undefined, createElement(StorageDetailsView, {
                StorageId: new StorageId(matchValue.fields[0]),
                UserData: props.UserData,
            }));
        case 27:
            return navigationContainer(new AuthorizedUrl(27, []), t("settings.title"), t("location.title"), "", undefined, createElement(LocationOverview, null));
        case 28:
            return navigationContainer(new AuthorizedUrl(27, []), t("settings.title"), t("location.title"), "", undefined, createElement(NewLocationView, null));
        case 30:
            return navigationContainer(new AuthorizedUrl(27, []), t("settings.title"), t("location.title"), "", undefined, createElement(EditLocationView, {
                LocationId: new LocationId(matchValue.fields[0]),
            }));
        case 29:
            return navigationContainer(new AuthorizedUrl(27, []), t("settings.title"), t("location.title"), "", undefined, createElement(LocationDetailsView, {
                LocationId: new LocationId(matchValue.fields[0]),
            }));
        case 31:
            return navigationContainer(new AuthorizedUrl(31, []), t("toolbox.title"), undefined, "", undefined, createElement(UserOverviewView, {
                UserData: props.UserData,
            }));
        case 32:
            return navigationContainer(new AuthorizedUrl(32, []), t("receivers.title"), undefined, "", undefined, createElement(NewUserView, {
                AccountSettings: props.AccountSettings,
                CustomerConfiguration: props.Configuration,
                OnBackPath: ["receivers", "users"],
            }));
        case 33: {
            const userId = matchValue.fields[0];
            return navigationContainer(new AuthorizedUrl(33, [userId]), t("receivers.title"), undefined, "", undefined, createElement(EditUserView, {
                AccountSettings: props.AccountSettings,
                CustomerConfiguration: props.Configuration,
                OnBackPath: ["receivers", "users", userId],
                UserId: new UserId_9(userId),
            }));
        }
        case 34:
            return navigationContainer(new AuthorizedUrl(118, []), t("toolbox.title"), undefined, "", undefined, createElement(ToolBoxView, {
                OnBackPath: ["receivers", "users"],
                UserData: props.UserData,
                UserId: matchValue.fields[0],
            }));
        case 35:
            return navigationContainer(new AuthorizedUrl(35, []), t("toolbox.title"), undefined, "", undefined, createElement(EmployeeOverviewView, {
                UserData: props.UserData,
            }));
        case 36:
            return navigationContainer(new AuthorizedUrl(36, []), t("receivers.title"), undefined, "", undefined, createElement(NewEmployeeView, {
                CustomerConfiguration: props.Configuration,
            }));
        case 37: {
            const employeeId = matchValue.fields[0];
            return navigationContainer(new AuthorizedUrl(37, [employeeId]), t("receivers.title"), undefined, "", undefined, createElement(EditEmployeeView, {
                CustomerConfiguration: props.Configuration,
                EmployeeId: new UserId_9(employeeId),
                OnBackPath: ["receivers", "employees", employeeId],
            }));
        }
        case 38:
            return navigationContainer(new AuthorizedUrl(118, []), t("toolbox.title"), undefined, "", undefined, createElement(ToolBoxView, {
                OnBackPath: ["receivers", "employees"],
                UserData: props.UserData,
                UserId: matchValue.fields[0],
            }));
        case 47:
            return navigationContainer(new AuthorizedUrl(47, []), t("toolbox.title"), undefined, "", undefined, createElement(ProjectOverviewView, {
                UserData: props.UserData,
            }));
        case 48:
            return navigationContainer(new AuthorizedUrl(48, []), t("receivers.title"), undefined, "", undefined, createElement(NewProjectView, {
                CustomerConfiguration: props.Configuration,
            }));
        case 49: {
            const projectId = matchValue.fields[0];
            return navigationContainer(new AuthorizedUrl(49, [projectId]), t("receivers.title"), undefined, "", undefined, createElement(EditProjectView, {
                CustomerConfiguration: props.Configuration,
                OnBackPath: ["receivers", "projects", projectId],
                ProjectId: new UserId_9(projectId),
            }));
        }
        case 50:
            return navigationContainer(new AuthorizedUrl(118, []), t("toolbox.title"), undefined, "", undefined, createElement(ToolBoxView, {
                OnBackPath: ["receivers", "projects"],
                UserData: props.UserData,
                UserId: matchValue.fields[0],
            }));
        case 39:
            return navigationContainer(new AuthorizedUrl(39, []), t("toolbox.title"), undefined, "", undefined, createElement(RoomOverviewView, {
                UserData: props.UserData,
            }));
        case 40:
            return navigationContainer(new AuthorizedUrl(40, []), t("receivers.title"), undefined, "", undefined, createElement(NewRoomView, {
                CustomerConfiguration: props.Configuration,
            }));
        case 41: {
            const roomId = matchValue.fields[0];
            return navigationContainer(new AuthorizedUrl(41, [roomId]), t("receivers.title"), undefined, "", undefined, createElement(EditRoomView, {
                CustomerConfiguration: props.Configuration,
                OnBackPath: ["receivers", "rooms", roomId],
                RoomId: new UserId_9(roomId),
            }));
        }
        case 42:
            return navigationContainer(new AuthorizedUrl(118, []), t("toolbox.title"), undefined, "", undefined, createElement(ToolBoxView, {
                OnBackPath: ["receivers", "rooms"],
                UserData: props.UserData,
                UserId: matchValue.fields[0],
            }));
        case 51:
            return navigationContainer(new AuthorizedUrl(51, []), t("toolbox.title"), undefined, "", undefined, createElement(SubcontractorOverviewView, {
                UserData: props.UserData,
            }));
        case 52:
            return navigationContainer(new AuthorizedUrl(52, []), t("receivers.title"), undefined, "", undefined, createElement(NewSubcontractorView, {
                Customer: props.UserData.Customer,
                CustomerConfiguration: props.Configuration,
            }));
        case 53: {
            const subcontractorId = matchValue.fields[0];
            return navigationContainer(new AuthorizedUrl(53, [subcontractorId]), t("receivers.title"), undefined, "", undefined, createElement(EditSubcontractorView, {
                Customer: props.UserData.Customer,
                CustomerConfiguration: props.Configuration,
                OnBackPath: ["receivers", "subcontractors", subcontractorId],
                SubcontractorId: new UserId_9(subcontractorId),
            }));
        }
        case 54:
            return navigationContainer(new AuthorizedUrl(118, []), t("toolbox.title"), undefined, "", undefined, createElement(ToolBoxView, {
                OnBackPath: ["receivers", "subcontractors"],
                UserData: props.UserData,
                UserId: matchValue.fields[0],
            }));
        case 55:
            return navigationContainer(new AuthorizedUrl(55, []), t("toolbox.title"), undefined, "", undefined, createElement(ConstructionSiteOverviewView, {
                UserData: props.UserData,
            }));
        case 56:
            return navigationContainer(new AuthorizedUrl(56, []), t("receivers.title"), undefined, "", undefined, createElement(NewConstructionSiteView, {
                CustomerConfiguration: props.Configuration,
            }));
        case 57: {
            const constructionSiteId = matchValue.fields[0];
            return navigationContainer(new AuthorizedUrl(57, [constructionSiteId]), t("receivers.title"), undefined, "", undefined, createElement(EditConstructionSiteView, {
                ConstructionSiteId: new UserId_9(constructionSiteId),
                CustomerConfiguration: props.Configuration,
                OnBackPath: ["receivers", "construction-sites", constructionSiteId],
            }));
        }
        case 58:
            return navigationContainer(new AuthorizedUrl(118, []), t("toolbox.title"), undefined, "", undefined, createElement(ToolBoxView, {
                OnBackPath: ["receivers", "construction-sites"],
                UserData: props.UserData,
                UserId: matchValue.fields[0],
            }));
        case 43:
            return navigationContainer(new AuthorizedUrl(43, []), t("toolbox.title"), undefined, "", undefined, createElement(ExternalPersonOverviewView, {
                UserData: props.UserData,
            }));
        case 44:
            return navigationContainer(new AuthorizedUrl(44, []), t("receivers.title"), undefined, "", undefined, createElement(NewExternalPersonView, {
                Customer: props.UserData.Customer,
                CustomerConfiguration: props.Configuration,
            }));
        case 45: {
            const externalPersonId = matchValue.fields[0];
            return navigationContainer(new AuthorizedUrl(45, [externalPersonId]), t("receivers.title"), undefined, "", undefined, createElement(EditExternalPersonView, {
                Customer: props.UserData.Customer,
                CustomerConfiguration: props.Configuration,
                ExternalPersonId: new UserId_9(externalPersonId),
                OnBackPath: ["receivers", "external-persons", externalPersonId],
            }));
        }
        case 46:
            return navigationContainer(new AuthorizedUrl(118, []), t("toolbox.title"), undefined, "", undefined, createElement(ToolBoxView, {
                OnBackPath: ["receivers", "external-persons"],
                UserData: props.UserData,
                UserId: matchValue.fields[0],
            }));
        case 59:
            return navigationContainer(new AuthorizedUrl(59, []), t("toolbox.title"), undefined, "", undefined, createElement(StudentOverviewView, {
                UserData: props.UserData,
            }));
        case 60:
            return navigationContainer(new AuthorizedUrl(60, []), t("receivers.title"), undefined, "", undefined, createElement(NewStudentView, {
                CustomerConfiguration: props.Configuration,
            }));
        case 61: {
            const studentId = matchValue.fields[0];
            return navigationContainer(new AuthorizedUrl(61, [studentId]), t("receivers.title"), undefined, "", undefined, createElement(EditStudentView, {
                CustomerConfiguration: props.Configuration,
                OnBackPath: ["receivers", "students", studentId],
                StudentId: new UserId_9(studentId),
            }));
        }
        case 62:
            return navigationContainer(new AuthorizedUrl(118, []), t("toolbox.title"), undefined, "", undefined, createElement(ToolBoxView, {
                OnBackPath: ["receivers", "students"],
                UserData: props.UserData,
                UserId: matchValue.fields[0],
            }));
        case 63:
            return navigationContainer(new AuthorizedUrl(63, []), t("toolbox.title"), undefined, "", undefined, createElement(SchoolClassOverviewView, {
                UserData: props.UserData,
            }));
        case 64:
            return navigationContainer(new AuthorizedUrl(64, []), t("receivers.title"), undefined, "", undefined, createElement(NewSchoolClassView, {
                CustomerConfiguration: props.Configuration,
            }));
        case 65: {
            const schoolClassId = matchValue.fields[0];
            return navigationContainer(new AuthorizedUrl(65, [schoolClassId]), t("receivers.title"), undefined, "", undefined, createElement(EditSchoolClassView, {
                CustomerConfiguration: props.Configuration,
                OnBackPath: ["receivers", "school-classes", schoolClassId],
                SchoolClassId: new UserId_9(schoolClassId),
            }));
        }
        case 66:
            return navigationContainer(new AuthorizedUrl(118, []), t("toolbox.title"), undefined, "", undefined, createElement(ToolBoxView, {
                OnBackPath: ["receivers", "school-classes"],
                UserData: props.UserData,
                UserId: matchValue.fields[0],
            }));
        case 67:
            return navigationContainer(new AuthorizedUrl(67, []), t("toolbox.title"), undefined, "", undefined, createElement(VehiclesOverviewView, {
                UserData: props.UserData,
            }));
        case 68:
            return navigationContainer(new AuthorizedUrl(68, []), t("receivers.title"), undefined, "", undefined, createElement(NewVehicleView, {
                CustomerConfiguration: props.Configuration,
            }));
        case 69: {
            const vehicleId = matchValue.fields[0];
            return navigationContainer(new AuthorizedUrl(69, [vehicleId]), t("receivers.title"), undefined, "", undefined, createElement(VehicleEditView, {
                CustomerConfiguration: props.Configuration,
                OnBackPath: ["receivers", "vehicles", vehicleId],
                VehicleId: new UserId_9(vehicleId),
            }));
        }
        case 70:
            return navigationContainer(new AuthorizedUrl(118, []), t("toolbox.title"), undefined, "", undefined, createElement(ToolBoxView, {
                OnBackPath: ["receivers", "vehicles"],
                UserData: props.UserData,
                UserId: matchValue.fields[0],
            }));
        case 75:
            return navigationContainer(new AuthorizedUrl(75, []), t("settings.title"), t("navbar.systemsettings"), "settings-top-navigation", "systemsettings-top-sub-navigation", createElement(SystemSettingsView, {
                AccountSettings: props.AccountSettings,
                OnConfigurationChanged: props.OnConfigurationChanged,
                UserData: props.UserData,
            }));
        case 76:
            return navigationContainer(new AuthorizedUrl(76, []), t("settings.title"), t("settings.custom_property.nav_header"), "settings-top-navigation", "custom-properties-top-sub-navigation", createElement(View, null));
        case 77: {
            const categoryRoutes = matchValue.fields[0];
            switch (categoryRoutes.tag) {
                case 1: {
                    const categoryId = categoryRoutes.fields[0];
                    return navigationContainer(new AuthorizedUrl(77, [new CategoryRoutes(1, [categoryId])]), t("settings.title"), t("category.categories"), "settings-top-navigation", "categories-sub-top-navigation", createElement(View_1, {
                        CategoryId: categoryId,
                    }));
                }
                case 2:
                    return navigationContainer(new AuthorizedUrl(77, [new CategoryRoutes(2, [])]), t("settings.title"), t("category.categories"), "settings-top-navigation", "categories-sub-top-navigation", createElement(NewCategoryView, null));
                case 3: {
                    const categoryId_1 = categoryRoutes.fields[0];
                    return navigationContainer(new AuthorizedUrl(77, [new CategoryRoutes(3, [categoryId_1])]), t("settings.title"), t("category.categories"), "settings-top-navigation", "categories-sub-top-navigation", createElement(EditCategoryView, {
                        CategoryId: categoryId_1,
                    }));
                }
                default:
                    return navigationContainer(new AuthorizedUrl(77, [new CategoryRoutes(0, [])]), t("settings.title"), t("category.categories"), "settings-top-navigation", "categories-sub-top-navigation", createElement(CategoriesOverviewView, null));
            }
        }
        case 78:
            return navigationContainer(new AuthorizedUrl(78, []), t("settings.title"), t("navbar.users"), "settings-top-navigation", "settings-user-top-navigation", createElement(UsersOverviewView, {
                AccountSettings: props.AccountSettings,
                UserData: props.UserData,
            }));
        case 80:
            return navigationContainer(new AuthorizedUrl(78, []), t("settings.title"), t("navbar.users"), "settings-top-navigation", "user-settings-sub-top-navigation", createElement(NewUserView, {
                AccountSettings: props.AccountSettings,
                CustomerConfiguration: props.Configuration,
                OnBackPath: ["settings", "users"],
            }));
        case 79: {
            const userId_2 = matchValue.fields[0];
            return navigationContainer(new AuthorizedUrl(78, []), t("settings.title"), t("navbar.users"), "", undefined, createElement(ToolBoxView, {
                OnBackPath: ["settings", "users"],
                OnEditPath: ["settings", "users", userId_2, "edit"],
                UserData: props.UserData,
                UserId: userId_2,
            }));
        }
        case 81: {
            const userId_3 = matchValue.fields[0];
            return navigationContainer(new AuthorizedUrl(78, []), t("settings.title"), t("navbar.users"), "", undefined, createElement(EditUserView, {
                AccountSettings: props.AccountSettings,
                CustomerConfiguration: props.Configuration,
                OnBackPath: ["settings", "users", userId_3],
                UserId: new UserId_9(userId_3),
            }));
        }
        case 71:
            if (props.AccountSettings.RestEnabled) {
                return navigationContainer(new AuthorizedUrl(71, []), t("toolbox.title"), undefined, "", undefined, createElement(ApiReceiversOverviewView, {
                    AccountSettings: props.AccountSettings,
                    UserData: props.UserData,
                }));
            }
            else {
                return createElement(NotFound, null);
            }
        case 72:
            if (props.AccountSettings.RestEnabled) {
                return navigationContainer(new AuthorizedUrl(72, []), t("receivers.title"), undefined, "", undefined, createElement(NewApiReceiverView, {
                    CustomerConfiguration: props.Configuration,
                }));
            }
            else {
                return createElement(NotFound, null);
            }
        case 73: {
            const apiReceiverId = matchValue.fields[0];
            if (props.AccountSettings.RestEnabled) {
                return navigationContainer(new AuthorizedUrl(73, [apiReceiverId]), t("receivers.title"), undefined, "", undefined, createElement(ApiReceiverEditView, {
                    ApiReceiverId: new UserId_9(apiReceiverId),
                    CustomerConfiguration: props.Configuration,
                }));
            }
            else {
                return createElement(NotFound, null);
            }
        }
        case 74:
            if (props.AccountSettings.RestEnabled) {
                return navigationContainer(new AuthorizedUrl(118, []), t("toolbox.title"), undefined, "", undefined, createElement(DetailsView, {
                    ApiReceiverId: new UserId_9(matchValue.fields[0]),
                    UserData: props.UserData,
                }));
            }
            else {
                return createElement(NotFound, null);
            }
        case 86:
            return navigationContainer(new AuthorizedUrl(86, []), t("profile.title"), undefined, "", undefined, createElement(ProfileView, {
                TokenDataDto: props.UserData,
            }));
        case 87:
            return navigationContainer(new AuthorizedUrl(87, []), t("customerdata.title"), undefined, "", undefined, createElement(CustomerDataView, {
                UserData: props.UserData,
            }));
        case 118:
            return navigationContainer(new AuthorizedUrl(118, []), t("toolbox.title"), undefined, "receiver-top-navigation", undefined, createElement(ReceiversOverviewView, {
                UserData: props.UserData,
            }));
        case 128:
            return navigationContainer(new AuthorizedUrl(118, []), t("toolbox.title"), undefined, "", undefined, createElement(ToolBoxView, {
                OnBackPath: ["receivers"],
                UserData: props.UserData,
                UserId: matchValue.fields[0],
            }));
        case 129:
            return navigationContainer(new AuthorizedUrl(118, []), t("toolbox.title"), undefined, "", undefined, createElement(View_2, {
                EventId: matchValue.fields[1],
                UserId: matchValue.fields[0],
            }));
        case 130:
            return navigationContainer(new AuthorizedUrl(130, []), t("report.title"), undefined, "report-top-navigation", undefined, createElement(View_3, {
                Configuration: props.Configuration,
                Customer: props.UserData.Customer,
            }));
        case 131:
            return navigationContainer(new AuthorizedUrl(130, []), t("report.title"), undefined, "report-top-navigation", undefined, createElement(ViewWithQueryParameter, {
                Configuration: props.Configuration,
                Customer: props.UserData.Customer,
                Parameter: matchValue.fields[0],
            }));
        case 117:
            return navigationContainer(new AuthorizedUrl(117, []), t("support.title"), undefined, "", undefined, createElement(View_4, null));
        case 132:
            return createElement(TestphaseEnd, {
                OnLogout: props.OnLogout,
            });
        case 133:
            return createElement(AccountCanceled, null);
        case 134:
            return createElement(AccountNotActivated, null);
        case 92:
            return navigationContainer(new AuthorizedUrl(92, []), t("settings.title"), t("shop.title"), "settings-top-navigation", "shop-top-sub-navigation", createElement(BarcodeShopView, {
                AccountSettings: props.AccountSettings,
            }));
        case 93:
            return navigationContainer(new AuthorizedUrl(93, []), t("settings.title"), t("importer.title"), "settings-top-navigation", "dataimport-top-sub-navigation", createElement(View_5, {
                AccountSettings: props.AccountSettings,
                CurrentUser: props.CurrentUser,
                TokenData: props.UserData,
            }));
        case 94:
            return navigationContainer(new AuthorizedUrl(94, []), t("importer.title"), undefined, "", undefined, createElement(View_6, {
                AccountSettings: props.AccountSettings,
                CurrentUser: props.CurrentUser,
            }));
        case 95:
            return navigationContainer(new AuthorizedUrl(95, []), t("importer.title"), undefined, "", undefined, createElement(View_7, {
                AccountSettings: props.AccountSettings,
                CurrentUser: props.CurrentUser,
            }));
        case 96:
            return navigationContainer(new AuthorizedUrl(96, []), t("importer.title"), undefined, "", undefined, createElement(View_8, {
                AccountSettings: props.AccountSettings,
                CurrentUser: props.CurrentUser,
            }));
        case 97:
            return navigationContainer(new AuthorizedUrl(97, []), t("importer.title"), undefined, "", undefined, createElement(View_9, {
                AccountSettings: props.AccountSettings,
                CurrentUser: props.CurrentUser,
            }));
        case 98:
            return navigationContainer(new AuthorizedUrl(98, []), t("importer.title"), undefined, "", undefined, createElement(View_10, {
                AccountSettings: props.AccountSettings,
                CurrentUser: props.CurrentUser,
            }));
        case 99:
            return navigationContainer(new AuthorizedUrl(99, []), t("importer.title"), undefined, "", undefined, createElement(View_11, {
                AccountSettings: props.AccountSettings,
                CurrentUser: props.CurrentUser,
            }));
        case 106:
            return navigationContainer(new AuthorizedUrl(106, []), t("importer.title"), undefined, "", undefined, createElement(View_12, {
                AccountSettings: props.AccountSettings,
                CurrentUser: props.CurrentUser,
            }));
        case 101:
            return navigationContainer(new AuthorizedUrl(101, []), t("importer.title"), undefined, "", undefined, createElement(View_13, {
                AccountSettings: props.AccountSettings,
                CurrentUser: props.CurrentUser,
            }));
        case 100:
            return navigationContainer(new AuthorizedUrl(100, []), t("importer.title"), undefined, "", undefined, createElement(View_14, {
                AccountSettings: props.AccountSettings,
                CurrentUser: props.CurrentUser,
            }));
        case 102:
            return navigationContainer(new AuthorizedUrl(102, []), t("importer.title"), undefined, "", undefined, createElement(View_15, {
                AccountSettings: props.AccountSettings,
                CurrentUser: props.CurrentUser,
            }));
        case 103:
            return navigationContainer(new AuthorizedUrl(103, []), t("importer.title"), undefined, "", undefined, createElement(View_16, {
                AccountSettings: props.AccountSettings,
                CurrentUser: props.CurrentUser,
            }));
        case 104:
            return navigationContainer(new AuthorizedUrl(104, []), t("importer.title"), undefined, "", undefined, createElement(View_17, {
                AccountSettings: props.AccountSettings,
                CurrentUser: props.CurrentUser,
            }));
        case 105:
            return navigationContainer(new AuthorizedUrl(105, []), t("importer.title"), undefined, "", undefined, createElement(View_18, {
                AccountSettings: props.AccountSettings,
                CurrentUser: props.CurrentUser,
            }));
        case 107:
            return navigationContainer(new AuthorizedUrl(107, []), t("importer.title"), undefined, "", undefined, createElement(ImporterView, {
                AccountSettings: props.AccountSettings,
                CurrentUser: props.CurrentUser,
            }));
        case 108:
            return navigationContainer(new AuthorizedUrl(108, []), t("importer.title"), undefined, "", undefined, createElement(View_19, {
                AccountSettings: props.AccountSettings,
                CurrentUser: props.CurrentUser,
            }));
        case 109:
            return navigationContainer(new AuthorizedUrl(109, []), t("importer.title"), undefined, "", undefined, createElement(View_20, {
                AccountSettings: props.AccountSettings,
                CurrentUser: props.CurrentUser,
            }));
        case 110:
            return navigationContainer(new AuthorizedUrl(110, []), t("importer.title"), undefined, "", undefined, createElement(View_21, {
                AccountSettings: props.AccountSettings,
                CurrentUser: props.CurrentUser,
            }));
        case 111:
            return navigationContainer(new AuthorizedUrl(111, []), t("importer.title"), undefined, "", undefined, createElement(View_22, {
                AccountSettings: props.AccountSettings,
                CurrentUser: props.CurrentUser,
            }));
        case 112:
            return navigationContainer(new AuthorizedUrl(112, []), t("importer.title"), undefined, "", undefined, createElement(View_23, {
                AccountSettings: props.AccountSettings,
                CurrentUser: props.CurrentUser,
            }));
        case 113:
            return navigationContainer(new AuthorizedUrl(113, []), t("importer.title"), undefined, "", undefined, createElement(View_24, {
                AccountSettings: props.AccountSettings,
                CurrentUser: props.CurrentUser,
            }));
        case 114:
            return navigationContainer(new AuthorizedUrl(114, []), t("importer.title"), undefined, "", undefined, createElement(View_25, {
                AccountSettings: props.AccountSettings,
                CurrentUser: props.CurrentUser,
            }));
        case 115:
            return navigationContainer(new AuthorizedUrl(115, []), t("importer.title"), undefined, "", undefined, createElement(View_26, {
                AccountSettings: props.AccountSettings,
                CurrentUser: props.CurrentUser,
            }));
        case 116:
            return navigationContainer(new AuthorizedUrl(116, []), t("importer.title"), undefined, "", undefined, createElement(View_27, {
                AccountSettings: props.AccountSettings,
                CurrentUser: props.CurrentUser,
            }));
        case 82:
            return navigationContainer(new AuthorizedUrl(82, []), t("general.dispolist"), undefined, "inventorylist-top-navigation", undefined, createElement(OverviewView_1, {
                UserData: props.UserData,
            }));
        case 83:
            return navigationContainer(new AuthorizedUrl(83, []), t("general.dispolist"), undefined, "", undefined, createElement(NewInventoryListView, {
                UserData: props.UserData,
            }));
        case 84: {
            const inventoryListId = matchValue.fields[0];
            return navigationContainer(new AuthorizedUrl(84, [inventoryListId]), t("dispolist.title"), undefined, "", undefined, createElement(DetailInventoryListView, {
                DispolistId: inventoryListId,
                UserData: props.UserData,
            }));
        }
        case 85: {
            const inventoryListId_1 = matchValue.fields[0];
            return navigationContainer(new AuthorizedUrl(85, [inventoryListId_1]), t("dispolist.title"), undefined, "", undefined, createElement(EditInventoryListView, {
                DispolistId: inventoryListId_1,
                UserData: props.UserData,
            }));
        }
        case 119:
            return navigationContainer(new AuthorizedUrl(119, []), t("navbar.calendar"), undefined, "calendar-top-navigation", undefined, createElement(CalendarView, null));
        case 120:
            return navigationContainer(new AuthorizedUrl(120, []), t("navbar.availability"), undefined, "availability-top-navigation", undefined, createElement(AvailabilityView, {}));
        case 122:
            return navigationContainer(new AuthorizedUrl(120, []), t("navbar.availability"), undefined, "availability-top-navigation", undefined, createElement(AvailabilityView, {
                ViewName: matchValue.fields[0],
            }));
        case 121:
            return navigationContainer(new AuthorizedUrl(121, []), t("navbar.utilization"), undefined, "utilization-top-navigation", undefined, createElement(UtilizationView, null));
        case 123:
            return navigationContainer(new AuthorizedUrl(123, []), t("navbar.reservation"), undefined, "reservation-top-navigation", undefined, createElement(ReservationView, {
                UserData: props.UserData,
            }));
        case 124:
            return navigationContainer(new AuthorizedUrl(124, []), t("navbar.reservation"), undefined, "", undefined, createElement(NewReservationForm, {
                AccountSettings: props.AccountSettings,
                User: props.CurrentUser,
                UserData: props.UserData,
            }));
        case 126:
            return navigationContainer(new AuthorizedUrl(123, []), t("navbar.reservation"), undefined, "reservation-top-navigation", undefined, createElement(DetailReservationView, {
                ReservationId: matchValue.fields[0],
                UserData: props.UserData,
            }));
        case 125:
            return navigationContainer(new AuthorizedUrl(123, []), t("navbar.reservation"), undefined, "reservation-top-navigation", undefined, createElement(EditReservationForm, {
                AccountSettings: props.AccountSettings,
                ReservationId: matchValue.fields[0],
                User: props.CurrentUser,
                UserData: props.UserData,
            }));
        case 127:
            return navigationContainer(new AuthorizedUrl(124, []), t("navbar.reservation"), undefined, "", undefined, createElement(NewReservationForm, {
                AccountSettings: props.AccountSettings,
                ReservationId: matchValue.fields[0],
                User: props.CurrentUser,
                UserData: props.UserData,
            }));
        case 135:
            return navigationContainer(new AuthorizedUrl(9, []), t("set.set"), undefined, "", undefined, createElement(NewSetView, {
                CustomerConfiguration: props.Configuration,
                UserData: props.UserData,
            }));
        case 137:
            return navigationContainer(new AuthorizedUrl(9, []), t("set.set"), undefined, "", undefined, createElement(SetDetailView, {
                CurrentUser: props.CurrentUser,
                SetId: matchValue.fields[0],
                UserData: props.UserData,
            }));
        case 138:
            return navigationContainer(new AuthorizedUrl(9, []), t("set.set"), undefined, "", undefined, createElement(EditSetView, {
                CustomerConfiguration: props.Configuration,
                SetId: new SetId_2(matchValue.fields[0]),
                UserData: props.UserData,
            }));
        case 136:
            return navigationContainer(new AuthorizedUrl(9, []), t("set.set"), undefined, "", undefined, createElement(CopySetView, {
                CustomerConfiguration: props.Configuration,
                SetId: new SetId_2(matchValue.fields[0]),
                UserData: props.UserData,
            }));
        case 139:
            return navigationContainer(new AuthorizedUrl(139, []), t("settings.title"), t("business_units.title"), "business-units-top-navigation", undefined, createElement(OverviewView_2, {
                CurrentUser: props.CurrentUser,
                UserData: props.UserData,
            }));
        case 140:
            return navigationContainer(new AuthorizedUrl(139, []), t("settings.title"), t("business_units.title"), "", undefined, createElement(NewBusinessUnitView, {
                UserData: props.UserData,
            }));
        case 141:
            return navigationContainer(new AuthorizedUrl(139, []), t("settings.title"), t("business_units.title"), "", undefined, createElement(BusinessUnitDetailView, {
                BusinessUnitId: new BusinessUnitId(matchValue.fields[0]),
                UserData: props.UserData,
            }));
        case 142:
            return navigationContainer(new AuthorizedUrl(139, []), t("settings.title"), t("business_units.title"), "", undefined, createElement(EditBusinessUnitView, {
                BusinessUnitId: new BusinessUnitId(matchValue.fields[0]),
                UserData: props.UserData,
            }));
        case 148:
            return navigationContainer(new AuthorizedUrl(148, []), t("settings.title"), t("navbar.inspection_templates"), "inspection-templates-top-navigation", undefined, createElement(OverviewView_3, {
                AccountSettings: props.AccountSettings,
            }));
        case 149:
            return navigationContainer(new AuthorizedUrl(148, []), t("settings.title"), t("navbar.inspection_templates"), "inspection-templates-top-navigation", undefined, createElement(NewView, null));
        case 150:
            return navigationContainer(new AuthorizedUrl(148, []), t("settings.title"), t("navbar.inspection_templates"), "inspection-templates-top-navigation", undefined, createElement(DetailView_2, {
                TemplateId: new InspectionTemplateId(matchValue.fields[0]),
            }));
        case 151:
            return navigationContainer(new AuthorizedUrl(148, []), t("settings.title"), t("navbar.inspection_templates"), "inspection-templates-top-navigation", undefined, createElement(EditView, {
                TemplateId: new InspectionTemplateId(matchValue.fields[0]),
            }));
        case 143:
            return navigationContainer(new AuthorizedUrl(143, []), t("settings.title"), t("navbar.procedures"), "procedure-templates-top-navigation", undefined, createElement(OverviewView_4, null));
        case 144:
            return navigationContainer(new AuthorizedUrl(143, []), t("settings.title"), t("navbar.procedures"), "procedure-templates-top-navigation", undefined, createElement(NewView_1, null));
        case 145:
            return navigationContainer(new AuthorizedUrl(143, []), t("settings.title"), t("navbar.procedures"), "procedure-templates-top-navigation", undefined, createElement(EditView_1, {
                ProcedureTemplateId: new ProcedureTemplateId(matchValue.fields[0]),
            }));
        case 146:
            return navigationContainer(new AuthorizedUrl(143, []), t("settings.title"), t("navbar.procedures"), "procedure-templates-top-navigation", undefined, createElement(CopyView, {
                ProcedureTemplateId: new ProcedureTemplateId(matchValue.fields[0]),
            }));
        case 147:
            return navigationContainer(new AuthorizedUrl(143, []), t("settings.title"), t("procedure.results"), "procedure-results-top-navigation", undefined, createElement(ResultsView, {
                ProcedureId: new ProcedureId(matchValue.fields[0]),
            }));
        case 152:
            return navigationContainer(new AuthorizedUrl(152, []), t("label_print.title"), undefined, "label-print-top-navigation", undefined, createElement(LabelPrintPage, null));
        case 153:
            return navigationContainer(new AuthorizedUrl(153, []), t("chat.title"), undefined, "chat-top-navigation", undefined, createElement(ChatOverviewView, {
                UserData: props.UserData,
            }));
        case 154:
            return createElement(BadRequest, null);
        case 155:
            return createElement(Unauthorized, null);
        case 156:
            return createElement(Forbidden, null);
        case 157:
            return createElement(NotFound, null);
        case 158:
            return createElement(InternalServerError, null);
        case 159:
            return createElement(LoadingPage, null);
        default:
            return createElement(View_28, {
                AccountSettings: props.AccountSettings,
                OnWizardCompleted: props.OnWizardCompleted,
            });
    }
}

export function ActiveGuestAuthorizedPage(props) {
    const matchValue = props.Url;
    switch (matchValue.tag) {
        case 1:
            return createElement(AssignEmailNotificationSuccessMessage, null);
        case 2:
            return createElement(AssignEmailNotificationRejectSuccessMessage, null);
        case 3:
            return createElement(ProcedureResultsPrintView, {
                Data: matchValue.fields[0],
            });
        case 4:
            return createElement(AssignmentProtocolView, {
                AssignmentType: matchValue.fields[0],
                Comment: matchValue.fields[6],
                EntityName: matchValue.fields[1],
                ImageUrl: unwrap(matchValue.fields[11]),
                InventoryNumber: matchValue.fields[2],
                QrCodeIds: unwrap(matchValue.fields[10]),
                ReceiverImageUrls: matchValue.fields[13],
                ReceiverName: matchValue.fields[4],
                ReturnDate: unwrap(matchValue.fields[8]),
                SenderImageUrls: matchValue.fields[12],
                SenderName: matchValue.fields[3],
                SignatureUrl: unwrap(matchValue.fields[9]),
                StorageName: unwrap(matchValue.fields[5]),
                Timestamp: matchValue.fields[7],
            });
        default:
            return createElement(AcceptEmailNotificationView, {
                AccessToken: matchValue.fields[1],
                NotificationId: matchValue.fields[0],
            });
    }
}

function hasAuthParamsInHash() {
    const hash = window.location.hash;
    if (hash.indexOf("code=") >= 0) {
        return hash.indexOf("state=") >= 0;
    }
    else {
        return false;
    }
}

export function ActivePage(props) {
    const auth = useAuth();
    const patternInput = reactApi.useState(false);
    const setHasTriedSignin = patternInput[1];
    const hasTriedSignin = patternInput[0];
    let effect;
    auth.events.addAccessTokenExpired(() => {
        auth.signinRedirect();
    });
    effect = ((props.CurrentUrl.tag === 1) ? ((props.UserData.tag === 0) ? (() => {
        props.ParseTokenFromParam();
    }) : (() => {
    })) : (() => {
        if (props.HealthFetched.tag === 0) {
        }
        else if ((((!hasAuthParams() && !auth.isAuthenticated) && (auth.activeNavigator == null)) && !auth.isLoading) && !hasTriedSignin) {
            auth.signinRedirect();
            setHasTriedSignin(true);
        }
        else {
            const matchValue_3 = hasAuthParams();
            let matchResult;
            if (props.UserData.tag === 0) {
                if (hasTriedSignin) {
                    matchResult = 1;
                }
                else if (matchValue_3) {
                    matchResult = 1;
                }
                else {
                    matchResult = 0;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    setHasTriedSignin(true);
                    props.ParseToken();
                    break;
                }
                case 1: {
                    break;
                }
            }
        }
    }));
    const dependencies = [auth, hasTriedSignin, props.UserData, props.HealthFetched];
    reactApi.useEffect(effect, dependencies);
    const dependencies_1_1 = [props.CurrentUrl, props.UserData, auth.isLoading, auth.isAuthenticated, props.AccountSettings, props.Configuration, props.CurrentUser, props.OnboardingWizardCompleted];
    return reactApi.useMemo(() => {
        const matchValue_6 = props.CurrentUrl;
        const matchValue_7 = props.UserData;
        const matchValue_8 = auth.isLoading;
        const matchValue_9 = auth.isAuthenticated;
        let matchResult_1, url_1, url_2, userData, url_3;
        if (matchValue_6.tag === 1) {
            if (matchValue_8) {
                matchResult_1 = 11;
            }
            else if (matchValue_7.tag === 1) {
                matchResult_1 = 13;
                url_3 = matchValue_6.fields[0];
            }
            else {
                matchResult_1 = 12;
            }
        }
        else {
            switch (matchValue_6.fields[0].tag) {
                case 154: {
                    matchResult_1 = 0;
                    break;
                }
                case 155: {
                    matchResult_1 = 1;
                    break;
                }
                case 156: {
                    matchResult_1 = 2;
                    break;
                }
                case 157: {
                    matchResult_1 = 3;
                    break;
                }
                case 158: {
                    matchResult_1 = 4;
                    break;
                }
                default:
                    if (matchValue_7.tag === 0) {
                        if (matchValue_8) {
                            if (matchValue_9) {
                                matchResult_1 = 8;
                            }
                            else {
                                matchResult_1 = 10;
                            }
                        }
                        else if (matchValue_9) {
                            if (equals(matchValue_6.fields[0], new AuthorizedUrl(1, []))) {
                                matchResult_1 = 6;
                                url_1 = matchValue_6.fields[0];
                            }
                            else {
                                matchResult_1 = 8;
                            }
                        }
                        else {
                            matchResult_1 = 9;
                        }
                    }
                    else if (matchValue_7.fields[0] != null) {
                        if (matchValue_8) {
                            if (matchValue_9) {
                                matchResult_1 = 8;
                            }
                            else {
                                matchResult_1 = 10;
                            }
                        }
                        else if (matchValue_9) {
                            matchResult_1 = 7;
                            url_2 = matchValue_6.fields[0];
                            userData = matchValue_7.fields[0];
                        }
                        else {
                            matchResult_1 = 9;
                        }
                    }
                    else if (matchValue_8) {
                        if (matchValue_9) {
                            matchResult_1 = 8;
                        }
                        else {
                            matchResult_1 = 10;
                        }
                    }
                    else if (matchValue_9) {
                        matchResult_1 = 5;
                    }
                    else {
                        matchResult_1 = 9;
                    }
            }
        }
        switch (matchResult_1) {
            case 0:
                return createElement(BadRequest, null);
            case 1:
                return createElement(Unauthorized, null);
            case 2:
                return createElement(Forbidden, null);
            case 3:
                return createElement(NotFound, null);
            case 4:
                return createElement(InternalServerError, null);
            case 5:
                return createElement(InvalidAuthError, null);
            case 6:
                return createElement(CreateAccountPage, null);
            case 7: {
                const matchValue_11 = props.AccountSettings;
                const matchValue_12 = props.Configuration;
                const matchValue_13 = props.CurrentUser;
                let matchResult_2, accountSettings, configuration, currentUser;
                if (matchValue_11.tag === 0) {
                    matchResult_2 = 1;
                }
                else if (matchValue_12.tag === 0) {
                    matchResult_2 = 1;
                }
                else if (matchValue_13.tag === 0) {
                    matchResult_2 = 1;
                }
                else {
                    matchResult_2 = 0;
                    accountSettings = matchValue_11.fields[0];
                    configuration = matchValue_12.fields[0];
                    currentUser = matchValue_13.fields[0];
                }
                switch (matchResult_2) {
                    case 0: {
                        let matchResult_3;
                        if (accountSettings.AccountState === "testPeriodOnboarding") {
                            if (!props.OnboardingWizardCompleted) {
                                matchResult_3 = 0;
                            }
                            else {
                                matchResult_3 = 1;
                            }
                        }
                        else {
                            matchResult_3 = 1;
                        }
                        switch (matchResult_3) {
                            case 0:
                                return createElement(View_28, {
                                    AccountSettings: accountSettings,
                                    OnWizardCompleted: props.OnWizardCompleted,
                                });
                            default:
                                return createElement(ActiveAuthorizedPage, {
                                    AccountSettings: accountSettings,
                                    Configuration: configuration,
                                    CurrentUser: currentUser,
                                    IsInTestphase: props.IsInTestphase,
                                    OnConfigurationChanged: props.OnConfigurationChanged,
                                    OnLogout: props.OnLogout,
                                    OnWizardCompleted: props.OnWizardCompleted,
                                    Url: url_2,
                                    UserData: userData,
                                });
                        }
                    }
                    default:
                        return createElement(LoadingPage, null);
                }
            }
            case 8:
                return createElement(LoadingPage, null);
            case 9:
                return createElement(Forbidden, null);
            case 10:
                return createElement(LoadingPage, null);
            case 11:
                return createElement(LoadingPage, null);
            case 12:
                return createElement(LoadingPage, null);
            default:
                return createElement(ActiveGuestAuthorizedPage, {
                    Url: url_3,
                });
        }
    }, dependencies_1_1);
}

